module.exports = __webpack_public_path__ + "static/media/GR.aee295db.webp";